"use client";

// TODO: This component must be deleted once we have the solution to refresh the token from auth.js on server side,
// Most probably after migrating to Next 15 version
import { useSessionRefresh } from "@repo/lib/hooks/account";
const RefreshUserSession = () => {
  useSessionRefresh();
  return null;
};
export default RefreshUserSession;